module.exports = __webpack_public_path__ + "img/sql-generator.2121d1f9.svg";